export default {"src":"/_next/static/media/Acxiom.c1704960.svg","height":80,"width":80};